import styled from '@emotion/styled';

import {
  DESKTOP_START_QUERY,
  LANDING_PAGE_MAX_WIDTH,
} from '../../styling/mixins/responsive';
import { pluckComponentProperty } from '../../utils/data-transformers/theme';

export const LandingPageContainer = styled.div`
  margin: auto;
  max-width: ${LANDING_PAGE_MAX_WIDTH}px;
`;

export const PaddedLandingPageComponent = styled.div`
  ${({ theme }) => PadComponent(theme)};
`;

export function PadComponent(theme) {
  return `
    padding-left: ${pluckComponentProperty(
      theme,
      'PaddedLandingPageComponent',
      'horizontalPadding',
    ) || 0};
    padding-right: ${pluckComponentProperty(
      theme,
      'PaddedLandingPageComponent',
      'horizontalPadding',
    ) || 0};
  `;
}

export const LandingPageWrapper = styled.div`
  padding: 0 0.5rem;

  @media (${DESKTOP_START_QUERY}) {
    margin-top: 1.5rem;
    padding: 0 1.5rem;
  }
`;
